"use strict";

exports.__esModule = true;
exports.ClockWidget = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _ClockElement = require("./ClockElement");
var _ClockFields = require("./ClockFields");
var _ClockHeader = require("./ClockHeader");
var _ClockThumbnail = require("./ClockThumbnail");
var _widgetGroups = require("../widgetGroups");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ClockWidget = exports.ClockWidget = {
  name: "Clock",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "ClockWidget.label",
    defaultMessage: "Clock"
  }),
  icon: "time",
  group: _widgetGroups.OTHER_WIDGET,
  createElement: function createElement(props) {
    return {
      type: "Clock",
      props: Object.assign({
        width: 256,
        height: 64,
        flex: 1,
        fontSize: 32
      }, props),
      children: []
    };
  },
  showInPalette: true,
  isParent: false,
  requiresContexts: [],
  suppliesContexts: [],
  optionalProps: ["fontFamily", "fontSize", "fontWeight", "fontStyle", "textDecoration", "textAlignment", "color", "backgroundColor"],
  requiresProps: ["x", "y", "width", "height"],
  suppliesProps: [],
  propConstraints: {
    width: {
      "default": 256,
      min: 32,
      max: 3840
    },
    height: {
      "default": 64,
      min: 32,
      max: 2160
    }
  },
  components: {
    Header: _ClockHeader.ClockHeader,
    Element: _ClockElement.ClockElement,
    Fields: _ClockFields.ClockFields,
    Thumbnail: _ClockThumbnail.ClockThumbnail
  }
};